import axios from 'axios'
import { Message } from '@arco-design/web-vue'

const request = axios.create({
  baseURL: import.meta.env.PROD ? import.meta.env.VITE_API_BASE_URL : '',
  timeout: 30000,
})

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    // 返回 Result<T> 对象，调用方直接 .data 取业务数据
    return response.data
  },
  (error) => {
    const body = error?.response?.data
    const msg = body?.message || error?.message || '请求失败'
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // 清理 Pinia store，然后导航到登录页
      import('@/store/user').then(m => {
        const { useUserStore } = m
        useUserStore().logout()
      })
      Message.error(msg || '登录已过期，请重新登录')
      // 使用 router.push 替代硬跳转
      import('@/router').then(m => {
        m.default.push('/login')
      })
    } else {
      // 统一错误提示，调用方无需再次 Message.error
      Message.error(msg)
    }
    return Promise.reject(error)
  }
)

export default request
